import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Wand2, Pencil, Trash2, Eye } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { api, errMsg, fcfa, imgUrl } from "@/lib/api";
import { Loading } from "@/components/RequireAuth";
import { StatusBadge, DemoBadge } from "@/components/Badges";
import { Button } from "@/components/ui/button";

export default function SellerProducts() {
  const { data, reload } = useApi("/seller/products");
  const del = async (p) => {
    if (!window.confirm(`Supprimer « ${p.title} » ?`)) return;
    try { await api.delete(`/seller/products/${p.id}`); toast.success("Produit supprimé"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="seller-products" className="space-y-5">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display text-3xl font-black tracking-tight">Produits</h1>
        <div className="flex gap-2">
          <Button asChild variant="outline" className="rounded-full" data-testid="new-product-manual"><Link to="/vendeur/produits/nouveau"><Plus className="mr-1 h-4 w-4" />Manuel</Link></Button>
          <Button asChild className="rounded-full bg-indigo-600 hover:bg-indigo-700" data-testid="new-product-ai"><Link to="/vendeur/ia"><Wand2 className="mr-1 h-4 w-4" />Avec l'IA</Link></Button>
        </div>
      </div>
      {!data ? <Loading /> : data.length === 0 ? <p data-testid="products-empty" className="rounded-xl border border-dashed p-10 text-center text-gray-500">Aucun produit. Commencez avec l'assistant IA.</p> : (
        <div className="divide-y rounded-xl border bg-white">
          {data.map((p) => (
            <div key={p.id} data-testid={`seller-product-${p.id}`} className="flex items-center gap-3 p-3">
              <img src={imgUrl(p.images?.[0])} alt="" className="h-14 w-14 rounded-lg bg-orange-50 object-cover" />
              <div className="min-w-0 flex-1">
                <p className="truncate font-semibold">{p.title}</p>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-gray-500">
                  <StatusBadge status={p.status} kind="product" />{p.demo && <DemoBadge />}
                  <span className="tnum">{fcfa(p.price, p.currency)}</span><span>· Stock : <b className={p.stock <= 3 ? "text-red-600" : ""}>{p.stock}</b></span>
                </div>
              </div>
              <Button asChild size="icon" variant="ghost" data-testid={`view-product-${p.id}`}><Link to={`/produit/${p.id}`}><Eye className="h-4 w-4" /></Link></Button>
              <Button asChild size="icon" variant="ghost" data-testid={`edit-product-${p.id}`}><Link to={`/vendeur/produits/${p.id}`}><Pencil className="h-4 w-4" /></Link></Button>
              <Button size="icon" variant="ghost" onClick={() => del(p)} data-testid={`delete-product-${p.id}`}><Trash2 className="h-4 w-4 text-red-600" /></Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
